export default (params) => ({
  trigger: {
    name: 'content_blocks.comparison.show_comparison_block',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'personalized',
          'non_personalized',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
    },
    nonInt: true,
  },
});
